import React from 'react';
import PhoneInput, { PhoneInputProps } from 'react-phone-input-2';
import { css } from '@emotion/react';
import 'react-phone-input-2/lib/style.css';
import tw from 'twin.macro';

interface CountryData {
  name: string;
  dialCode: string;
  countryCode: string;
  format: string;
}

interface PhoneProps extends Omit<PhoneInputProps, 'country'> {
  inputRef?: React.RefObject<HTMLDivElement>;
  onChange?: (v: string) => void;
  country?: string | null;
}

const PhoneNumber: React.FC<PhoneProps> = ({ inputRef, country, onChange, value, ...props }) => {
  const parts = navigator.language?.split('-');
  const browserCountry = parts.length > 1 ? parts[1].toLowerCase() : parts[0].toLowerCase() ?? [];

  // TODO: Validate country ?? browserCountry is valid country code
  const validatedCountry = (country ?? browserCountry ?? 'us').toLowerCase();

  return (
    <div
      css={css`
        .react-tel-input {
          div {
            ${tw`font-normal`}
          }

          .form-control {
            ${tw`h-input rounded-input border-color-input-box`}

            width: 100%;
            padding: 0.67857143em 1em 0.67857143em 48px;
            line-height: 1.21428571em;

            &:focus {
              border-color: #85b7d9;
            }

            &:disabled {
              opacity: 0.45;
              --border-opacity: 0.45;

              + .flag-dropdown {
                --border-opacity: 0.45;
                opacity: 0.45;
              }
            }
          }

          .flag-dropdown {
            ${tw`border-color-input-box rounded-input bg-white`}
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;

            & .selected-flag {
              ${tw`rounded-input`}
              &:hover {
                background: #f5f5f5;
              }
            }
          }
        }
      `}
      ref={inputRef}
      dir='ltr'
    >
      <PhoneInput
        {...props}
        disableInitialCountryGuess={false}
        disableCountryGuess={false}
        country={validatedCountry}
        inputProps={{ autoComplete: 'off' }}
        value={value || ''}
        onChange={(
          value: string,
          _data: CountryData,
          _event: React.ChangeEvent<HTMLInputElement>,
          _formattedValue: string
        ): void => {
          onChange && onChange(`+${value}`);
        }}
        onBlur={(e: React.FocusEvent<HTMLInputElement>, data: CountryData): void => {
          if (data.dialCode && `+${data.dialCode}`.includes(e.target.value)) {
            onChange && onChange('');
          }
        }}
      />
    </div>
  );
};

export default PhoneNumber;
